import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import { FileTextOutlined, ReloadOutlined } from "@ant-design/icons";
import CardPage from "../../../layout/CardPage";
import TablaSolicitudes from "../tabla/TablaSolicitudes";
import { useSolicitudesFilters } from "../../../hooks/useSolicitudesFilters";
import { BusquedaSolicitudes } from "../filtros/BusquedaSolicitudes";
import { reloadAllSilencioso, getSolicitudes } from "../../../context/actions/solicitudesActions";

export const ListaSolicitudes = ({ onCrearSolicitud, onOpenChat }) => {
  const dispatch = useDispatch();
  const { solicitudes, loading } = useSelector((state) => state.solicitudesReducer);

  const {
    filteredData,
    filterInfo,
    isFiltered,
    activeStatusFilter,
    searchTerm,
    setSearchTerm,
    tableRef,
    handleTableChange,
    handleStatusFilterClick,
    handleResetAllFilters
  } = useSolicitudesFilters(solicitudes);

  const handleActualizar = () => {
    dispatch(getSolicitudes());
  };

  return (
    <CardPage titulo={`Mis Solicitudes ${filteredData.length}${filteredData.length !== solicitudes.length ? ` de ${solicitudes.length}` : ''}`}>
      {/* banner de filtros activos */}
      {isFiltered && filterInfo.label && (
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16, 
          padding: '8px 16px',
          backgroundColor: '#fff2e8',
          borderRadius: '6px',
          border: '1px solid #ffb366'
        }}>
          <span style={{ 
            color: '#d46b08',
            fontSize: '14px',
            marginRight: '12px'
          }}>
            Mostrando: {filterInfo.label} ({filterInfo.count} solicitudes)
          </span>
          <Button
            size="small"
            type="text"
            onClick={handleResetAllFilters}
            style={{ 
              color: '#ff4d4f',
              fontSize: '12px'
            }}
          >
            Limpiar filtros
          </Button>
        </div>
      )}

      {/* controles superiores: Búsqueda | Botón */}
      <div className="controles-superiores" style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginTop: '16px',
        gap: '16px'
      }}>
        {/* búsqueda a la izquierda */}
        <div style={{ flex: '1', maxWidth: '400px' }}>
          <BusquedaSolicitudes
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            style={{ marginBottom: 0 }}
          />
        </div>

        {/* botones a la derecha */}
        <div style={{ flex: '0 0 auto', display: 'flex', gap: '8px' }}>
          <Button 
            type="default"
            icon={<ReloadOutlined />}
            onClick={handleActualizar}
            size="middle"
            style={{ 
              borderColor: '#1890ff',
              color: '#1890ff'
            }}
          >
            Actualizar
          </Button>
          <Button 
            type="primary" 
            icon={<FileTextOutlined />}
            onClick={onCrearSolicitud}
            className="gradient-button"
            size="middle"
          >
            Nueva Solicitud
          </Button>
        </div>
      </div>

      {/* tabla con filtros de columnas */}
      <TablaSolicitudes
        ref={tableRef}
        dataSource={filteredData}
        originalDataSource={solicitudes}
        loading={loading}
        onOpenChat={onOpenChat}
        onTableChange={handleTableChange}
      />
    </CardPage>
  );
};